/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { Projeto, ProjetosComponentesModificados } from "../types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { red } from "@mui/material/colors";
import { Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { AddComponente } from "./AddComponente";

import { ID_MODULO } from "src/components/componentes/types";
import { ComponenteCalculo, DadosCalculoPedido, PedidoCalculoResponse, SITUACAO_COMPONENTE } from "./type";
import { BehaviorSubject } from "rxjs";
import { useObservable } from "src/framework/store/storeUtil";
import { RowComponente } from "./RowComponente";
import { useHistory } from "react-router-dom";
import { CorpoEmail, EmailDialog } from "src/components/geral/dialogs/EmailDialog";
import { EmailInterface } from "src/framework/store/EmailStore";
import { SEGMENTO_PROJETO } from "../historico/HistoricoMigrado/utils/constants";
import { TrocaPendente } from "./TrocaPendente";
import { ConfiguracaoStore } from "src/framework/store/ConfiguracaoStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { InputInfo } from "src/framework/components/forms/inputs/InputInfo/InputInfo";



const ACAO_NOVO = "novo";
const ACAO_SUBSTITUICAO = "substituicao";
const GRUPO_MERCADORIA = "GRUPOS_MERCADORIA_BLOQUEADOS";

export interface IEdicaoAvancada {
    codigoProjeto: string;
}

export const URL_EDICAO_AVANCADA = "projetos/edicao_avancada";

const DEFAULT_DADOS_CALCULO: PedidoCalculoResponse = {
    componentes: {
        area_total: 0,
        peso_gerador: 0,
        peso_telhado: 0,
        potencia_gerador: 0,
        valor: 0
    },
    modificados: {
        area_total: 0,
        peso_gerador: 0,
        peso_telhado: 0,
        potencia_gerador: 0,
        valor: 0
    }
}

const verificaPendenciaDeTroca = (projetoData: Projeto | Partial<Projeto> | null)=>{
    let pendenteAplicacao = false
    const substituidos = projetoData?.componentes_modificados?.filter(item => item.situacao === SITUACAO_COMPONENTE.NOVO && !!item.componente_substituido_id) || []
    if (substituidos.length) {
        const ids = substituidos.map(item => item.componente_id)
        const componentesIds = projetoData?.componentes?.map(item => item.componente_id) || []
        for (const id of ids) {
            if (!componentesIds.includes(id)) pendenteAplicacao = true
        }
    }
    return pendenteAplicacao
}

const possuiPrecoZero = (componentes: ProjetosComponentesModificados[] | null | undefined): boolean =>{
    if (!componentes || !componentes?.length) return false;
    const componentesVigentes = componentes.filter(item => item.situacao !== SITUACAO_COMPONENTE.SUBSTITUIDO && item.situacao !== SITUACAO_COMPONENTE.EXCLUIDO)
    return componentesVigentes.some(item => Number(item.valor || 0) === 0)
}

const edicaoRows$ = new BehaviorSubject<ReactNode>("");

const EdicaoAvancada: FC<IEdicaoAvancada> = ({ codigoProjeto }) => {
    const history = useHistory();

    const [trocaPendenteModal, setTrocaPendenteModal] = useState<{ status: boolean; data: Projeto | null }>({ status: false, data: null })
    const [showApplyChangeButton, setShowApplyChangeButton] = useState(false)
    const [projeto, setProjeto] = useState<Partial<Projeto> | null>(null);
    const [readOnly] = useState<boolean>(false);
    const [openModalEmail, setOpenModalEmail] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [componentesCache, setComponentesCache] = useState<any[]>([]);
    const [modelosEmail, setModelosEmail] = useState<EmailInterface[]>([]);
    const [componentesPrecoCache, setComponentesPrecoCache] = useState<any[]>([]);
    const [categoria, setCategoria] = useState<number>(0);
    const [notIn, setNotIn] = useState<number[]>([]);
    const [componenteEdicao, setComponenteEdicao] = useState<number>(0);
    const [dadosCalculo, setDadosCalculo] = useState<PedidoCalculoResponse>({...DEFAULT_DADOS_CALCULO});
    const rows = useObservable(edicaoRows$);

    const store = new ConfiguracaoStore(api, GRUPO_MERCADORIA);
    
    const [acao, setAcao] = useState<string>(ACAO_NOVO);
    
    const [openModal, setOpenModal] = useState(false);

    const getModelosEmail = useCallback(async () => {
        const request: IDataRequest = {
            url: URL_EDICAO_AVANCADA + `/modelos/email`,
            data: dadosCalculo
        }

        const result: IDataResponse = await api.get(request);

        if (result.statusCode === STATUS_CODE.OK) {
            const _modelosEmail = result.data || [];
            setModelosEmail(_modelosEmail);
        } else {
            // todo
            setModelosEmail([]);
        }
    }, [projeto]);

    const salvar = useCallback(async ({ showNotification = true, modificados = undefined, enviarPagamento = true }: { showNotification?: boolean; modificados?: ProjetosComponentesModificados[]; enviarPagamento?: boolean } = {}) => {
        const _componentesModificados = modificados || projeto?.componentes_modificados;

        if (_componentesModificados?.every((c) => c.situacao === SITUACAO_COMPONENTE.ORIGINAL)) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: ["Nenhuma alteração detectada!"],
                onClose: async () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2_500,
            })
            notifierStore.setOpen(true);

            return false;
        }

        const request: IDataRequest = {
            url: URL_EDICAO_AVANCADA + `/salvar/${projeto?.id}`,
            data: {
                componentes_modificados: _componentesModificados,
                enviarPagamento,
            }
        }

        const result: IDataResponse = await api.post(request);

        if (showNotification && result.statusCode === STATUS_CODE.OK) {
            notifierStore.setNotifier({
                title: "Aviso",
                timeOut: 0,
                content: ["Componentes na edição foram salvos com sucesso!"],
                onClose: async () => {
                    await getComponentesCache();
                    notifierStore.setOpen(false)
                    history.push(`/projetos/menu-projetos`);
                },
            })
            notifierStore.setOpen(true);
        }

        return true

    }, [projeto]);

    const salvarEnviarEmail = useCallback( async (corpoEmail: CorpoEmail | null ) => {
        try {
            if (!corpoEmail) {
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: ["O modelo de email não foi selecionado!"],
                    onClose: () => {
                        notifierStore.setOpen(false)
                    },
                    timeOut: 2_500,
                })
                notifierStore.setOpen(true);
    
                return;
            }
    
            await salvar({ showNotification: false });
    
            const enviarEmailRequest: IDataRequest = {
                url: URL_EDICAO_AVANCADA + `/enviar/email/${projeto?.id}`,
                data: corpoEmail
            }
    
            const response: IDataResponse = await api.post(enviarEmailRequest);
    
            if (response.statusCode === STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: ["E-mail enviado com sucesso!"],
                    onClose: () => {
                        notifierStore.setOpen(false)
                        history.push(`/projetos/menu-projetos`);
                    },
                    timeOut: 0,
                })
                notifierStore.setOpen(true);
            }
        } catch (error) {
            
        } finally {
            setOpenModalEmail(false);
        }

    } , [projeto])

    const getDadosCalculo = useCallback(async () => {
        try {
            setLoading(true)
            const _componentesOriginais = projeto?.componentes_originais || [];

            const _componentesModificados = projeto?.componentes_modificados?.filter((c) => {
                return ![SITUACAO_COMPONENTE.EXCLUIDO, SITUACAO_COMPONENTE.SUBSTITUIDO].includes(c.situacao)
            }) || [];

            const _componentes = _componentesOriginais.map((c) => {
                const componenteCache = componentesCache.find((cached: any) => cached.id === c.componente_id)

                const componenteCalculo: ComponenteCalculo = {
                    categoria_componentes_id: parseInt(`${c?.categoria_componentes_id}`),
                    componente_id: parseInt(`${c.componente_id}`),
                    peso: parseFloat(`${componenteCache?.peso}`),
                    quantidade: c.quantidade,
                    valor: c.valor_unitario * c.quantidade,
                    valor_unitario: c.valor_unitario
                }

                if (c.categoria_componentes_id === ID_MODULO) {
                    let potencia = 0;
                    let altura = 0;
                    let largura = 0;

                

                    if (componenteCache) {
                        if (componenteCache["atributos"]) {
                            potencia = parseFloat(`${componenteCache["atributos"]["MODULO_POTENCIA"]}`);
                            altura = parseFloat(`${componenteCache["atributos"]["MODULO_ALTURA_CALCULO"]}`);
                            largura = parseFloat(`${componenteCache["atributos"]["MODULO_LARGURA_CALCULO"]}`);
                        }
                    }
                    // Adicionar potência
                    componenteCalculo.potencia = potencia;
                    componenteCalculo.altura = altura;
                    componenteCalculo.largura = largura;
                }

                return componenteCalculo
            });

            const _modificados = _componentesModificados.map((c) => {
                const componenteCache = componentesCache.find((cached: any) => cached.id === c.componente_id)

                const componenteCalculo: ComponenteCalculo = {
                    categoria_componentes_id: parseInt(`${c.categoria_componentes_id}`),
                    componente_id: parseInt(`${c.componente_id}`),
                    peso: parseFloat(`${componenteCache?.peso}`),
                    quantidade: c.quantidade,
                    valor: c.valor,
                    valor_unitario: c.valor_unitario
                }

                if (c.categoria_componentes_id === ID_MODULO) {
                    let potencia = 0;
                    let altura = 0;
                    let largura = 0;

                    const modulos = componentesCache.filter((cached: any) => {
                        return cached.categoria_componentes_id === ID_MODULO
                    });

                    const idxModulo = modulos.findIndex((componenteCached: any) => {
                        return c.componente_id === componenteCached.id
                    });

                    if (idxModulo > -1) {
                        if (modulos[idxModulo]["atributos"]) {
                            potencia = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_POTENCIA"]}`);
                            altura = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_ALTURA_CALCULO"]}`);
                            largura = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_LARGURA_CALCULO"]}`);
                        }
                    }
                    // Adicionar potência
                    componenteCalculo.potencia = potencia
                    componenteCalculo.altura = altura;
                    componenteCalculo.largura = largura;
                }

                return componenteCalculo
            })

            const dadosCalculo: DadosCalculoPedido = {
                componentes: _componentes,
                modificados: _modificados,
            }

            const request: IDataRequest = {
                url: URL_EDICAO_AVANCADA + `/dados/calculo`,
                data: dadosCalculo
            }

            const result: IDataResponse = await apiNoLoading.post(request);

            if (result.statusCode === STATUS_CODE.OK) {
                const _dadosCalculo = result.data || DEFAULT_DADOS_CALCULO;
                setDadosCalculo(_dadosCalculo);
            }
        } catch (e) {

        } finally {
            setLoading(false)
        }
        
    }, [projeto?.componentes_modificados]);

    const getComponentesPrecos = async (estadoId: string) => {
        const requestComponentes: IDataRequest = {
            url: `/estoque/componentes_precos/?estado_id=${estadoId}`,
        }

        const result = await api.get(requestComponentes);

        if (result.statusCode === STATUS_CODE.OK) {
            const _componentesPrecos = result.data;
            setComponentesPrecoCache(_componentesPrecos);
        } else {
            setComponentesPrecoCache([]);
        }
    }

    const getComponentesCache = useCallback(async () => {
        const requestComponentes: IDataRequest = {
            url: "/estoque/componentes/?orderby=modelo&includes=atributos",
        }

        const result = await api.get(requestComponentes);

        if (result.statusCode === STATUS_CODE.OK) {
            const _componentesCache = result.data;
            setComponentesCache(_componentesCache);
        } else {
            setComponentesCache([]);
        }
    }, [projeto]);

    
    const getProjeto = useCallback( async () => {
        const request: IDataRequest = {
            url: URL_EDICAO_AVANCADA + `/consultar/${codigoProjeto}`,
        }

        try {
            const result: IDataResponse<Projeto[]> = await api.get(request);

            if (result.data) {
                // for (const modificado of result.data[0].componentes_modificados || []) {
                //     modificado.valor_original = modificado.valor
                // }

                if([String(SEGMENTO_PROJETO.VERTICAL_ONGRID), String(SEGMENTO_PROJETO.VERTICAL_OFFGRID)].includes(String(result.data[0]?.segmento)) && result.data[0]?.tipo === 'vertical'){
                    notifierStore.setNotifier({
                        title: "Aviso",
                        content: `Projeto ${result.data[0].codigo_venda} é um projeto de vertical, edição avançada não permitida!`,
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false);
                            history.goBack();
                        }
                    })
                    notifierStore.setOpen(true)     
                }

                if (result.data[0]?.cidade?.estado_id) {
                   await getComponentesPrecos(result.data[0].cidade.estado_id) 
                }

                if (result.data[0]?.calculo) {
                    setDadosCalculo(result.data[0].calculo)
                }

                setProjeto(result.data[0]);

                return result.data[0]
            }

            return null
        } catch (error) {
            return null
            // TODO: Tratar erro
        }
    }, [codigoProjeto]);

    const renderUfCliente = () => {
        if (projeto) {
            const cidade: any = { ...projeto.cidade };
            return cidade?.nome + ", " +  cidade?.estado_id
        }
    };

    const renderPotencias = (): React.ReactNode => {
        if (dadosCalculo) {
            const potenciaOriginal = `${Formater.toString(dadosCalculo?.componentes.potencia_gerador, TypeRecords.DECIMAL2)}`
            const potenciaModificada = `${Formater.toString(dadosCalculo?.modificados.potencia_gerador, TypeRecords.DECIMAL2)}`

            const excedido = dadosCalculo?.componentes?.potencia_gerador < dadosCalculo?.modificados?.potencia_gerador;

            return <>
                {`${potenciaOriginal}  kW / `} <span style={{ color: excedido ? red[500] : "inherit" }}>{`${potenciaModificada} kW`}</span>
            </>;
        }
        return " - "
    };

    const renderArea = (): React.ReactNode => {
        const segmento = projeto?.segmento || "";
        const tipo = projeto?.tipo || "";
        if(segmento?.includes("offgrid") && tipo === "dimensionado") return " - ";
        if (dadosCalculo) {
            const areaTotalOriginal = `${Formater.toString(dadosCalculo.componentes.area_total, TypeRecords.DECIMAL2)}`
            const areaTotalModificada = `${Formater.toString(dadosCalculo.modificados.area_total, TypeRecords.DECIMAL2)}`

            const excedido = dadosCalculo.componentes.area_total < dadosCalculo.modificados.area_total;

            return <>
                {`${areaTotalOriginal}  m² / `} <span style={{ color: excedido ? red[500] : "inherit" }}>{`${areaTotalModificada} m²`}</span>
            </>;
        }
        return " - "
    };

    const renderValor = useCallback(() => {
        const valorItem = dadosCalculo?.componentes?.valor || 0;
        const valorItemModificado = dadosCalculo?.modificados?.valor || 0;
        const valorOriginal = `${Formater.toString(valorItem, TypeRecords.CURRENCY)}`
        const valorModificada = `${Formater.toString(valorItemModificado, TypeRecords.CURRENCY)}`

        const excedido = valorItem !== valorItemModificado;

        return <>
            {`${valorOriginal} / `} <span style={{ color: excedido ? red[500] : "inherit" }}>{`${valorModificada}`}</span>
        </>;
    }, [dadosCalculo]);

    const renderValorServico = (): React.ReactNode => {
        return Formater.toString(projeto?.valor_servico, TypeRecords.CURRENCY)
    };


    const renderPesoTelhado = (): React.ReactNode => {
        const segmento = projeto?.segmento || "";
        const tipo = projeto?.tipo || "";
        if(segmento?.includes("offgrid") && tipo === "dimensionado") return " - ";
        if (dadosCalculo) {
            const pesoOriginalTelhado = Formater.toString(dadosCalculo.componentes.peso_telhado, TypeRecords.DECIMAL2);
            const pesoModificadoTelhado = Formater.toString(dadosCalculo.modificados.peso_telhado, TypeRecords.DECIMAL2);
            const excedido = dadosCalculo.componentes.peso_telhado < dadosCalculo.modificados.peso_telhado;

            return <>
                {`${pesoOriginalTelhado} kg / `} <span style={{ color: excedido ? red[500] : "inherit" }}>{`${pesoModificadoTelhado} kg`}</span>
            </>;
        }
        return " - "
    }

    const renderPesoGerador = (): React.ReactNode => {
        const segmento = projeto?.segmento || "";
        const tipo = projeto?.tipo || "";
        if(segmento?.includes("offgrid") && tipo === "dimensionado") return " - ";
        if (dadosCalculo) {
            const pesoOriginalGerador = Formater.toString(dadosCalculo.componentes.peso_gerador, TypeRecords.DECIMAL2);
            const pesoModificadoGerador = Formater.toString(dadosCalculo.modificados.peso_gerador, TypeRecords.DECIMAL2);

            const excedido = dadosCalculo.componentes.peso_gerador < dadosCalculo.modificados.peso_gerador;

            return <>
                {`${pesoOriginalGerador} kg / `} <span style={{ color: excedido ? red[500] : "inherit" }}>{`${pesoModificadoGerador} kg`}</span>
            </>;
        }
        return " - "
    }

    const handleAddComponente = (componente: any): void => {
        const state = { ...projeto };
        const _componente: any = { ...componente, novo: true }
        const _componentePreco = componentesPrecoCache.find((c) => c.componente_id === componente.id)
       
        if (acao === ACAO_NOVO) {

            state?.componentes_modificados?.push({
                projeto_id: state.id || 0,
                componente_id: parseInt(`${componente.id}`),
                quantidade: 1,
                valor: 0,
                valor_unitario: _componentePreco?.valor,
                componente_substituido_id: componenteEdicao > 0 ? componenteEdicao : null,
                situacao: SITUACAO_COMPONENTE.NOVO,
                categoria_componentes_id: _componente.categoria_componentes_id,
                modelo: _componente.modelo,
                quantidade_original: 1,
                valor_original: _componentePreco?.valor
            });
            

        }

        if (acao === ACAO_SUBSTITUICAO) {

            const idxComponenteSubistituido = state?.componentes_modificados?.findIndex((c) => {
                return c.componente_id === componenteEdicao
            })
            
            const countSubstitutos: number = Number(state?.componentes_modificados?.filter(c => c.componente_substituido_id === componenteEdicao)?.length) || 0;

            const substituido = state?.componentes_modificados?.find((c) => {
                return c.componente_id === componenteEdicao
            })

            let valor = 0;
            if (substituido && countSubstitutos === 0) {
                valor = substituido?.valor || 0;
            }

            const substituto: ProjetosComponentesModificados = {
                projeto_id: state.id || 0,
                componente_id: parseInt(`${componente.id}`),
                quantidade: 1,
                valor: _componentePreco?.valor,
                valor_unitario: _componentePreco?.valor,
                componente_substituido_id: componenteEdicao > 0 ? componenteEdicao : null,
                situacao: SITUACAO_COMPONENTE.NOVO,
                categoria_componentes_id: _componente.categoria_componentes_id,
                modelo: _componente.modelo,
                quantidade_original: 1,
                valor_original: _componentePreco?.valor
            }

            substituto.quantidade = calcularQuantidade({ componenteSubstituido: substituido, componenteSubstituto: substituto })

            if (substituto.categoria_componentes_id === ID_MODULO && countSubstitutos === 0) {
                substituto.valor = valor;
                substituto.valor_unitario = DecimalUtil.toFixed(substituto.valor / substituto.quantidade, 2);
                substituto.valor = DecimalUtil.toFixed(substituto.valor_unitario * substituto.quantidade, 2);
            } else {
                substituto.valor = substituido?.valor || 0;
                substituto.valor_unitario = DecimalUtil.toFixed(Number(substituido?.valor) / substituto.quantidade, 2)
            }

            // substituto.valor_unitario = DecimalUtil.toFixed(Number(substituto?.valor) / substituto.quantidade, 2)
            
            if (Number(idxComponenteSubistituido) > -1 && substituido && state?.componentes_modificados?.[Number(idxComponenteSubistituido)]) {
                substituido.situacao = SITUACAO_COMPONENTE.SUBSTITUIDO
                state.componentes_modificados[Number(idxComponenteSubistituido)] = substituido;
            }

            state?.componentes_modificados?.push(substituto);
        }

        setProjeto({ ...state });
        setComponenteEdicao(0);

    }

    const calcularQuantidade = (
        { componenteSubstituido, componenteSubstituto }:
            { componenteSubstituido: any, componenteSubstituto: any }
    ): number => {
        // calculo
        if (componenteSubstituto.categoria_componentes_id === ID_MODULO) {
            let qtdModulos: number = 1;
            const _moduloSubstituido = componentesCache.find((c) => {
                return c.id === componenteSubstituido.componente_id
            })

            const _moduloSubstituto = componentesCache.find((c) => {
                return c.id === componenteSubstituto.componente_id
            })

            // Math.ceil((Number("") * componenteSubstituido.quantidade) / Number(""))
            if (_moduloSubstituido && _moduloSubstituto) {
                qtdModulos = Math.ceil((Number(_moduloSubstituido.atributos.MODULO_POTENCIA) * componenteSubstituido.quantidade) / Number(_moduloSubstituto.atributos.MODULO_POTENCIA));
            }



            return qtdModulos;
        }

        return componenteSubstituido?.quantidade || 0;
    }

    const handleNotIn = async (): Promise<void> => {
        if (projeto) {
            const _notIn: any = (projeto as any)?.componentes_modificados.map((m: any) => {
                return m.componente_id
            }) || [];

            // Filtrar para não exibir os componentes de grupos de mercadoria bloqueado
            let gruposMercadoriaBloqueado = await store.list().then((parametros) => {
                return (parametros && parametros[0]?.valor) || [];
            });
            if (gruposMercadoriaBloqueado?.length) {
                gruposMercadoriaBloqueado = gruposMercadoriaBloqueado?.split(',');
                const componentesBloqueados = componentesCache?.filter((c) => {
                    return gruposMercadoriaBloqueado?.includes(c.grupo_mercadoria);
                }) || [];

                if (componentesBloqueados?.length) {
                    componentesBloqueados.forEach(c => {
                        _notIn.push(c.id)
                    })
                }
            }

            setNotIn([..._notIn])
        }
    }
    

    useEffect(() => {
        (async () => {
            await getComponentesCache();
            await getModelosEmail()
            const projetoData = await getProjeto();
            if (projetoData) {
                const pendenteTroca = verificaPendenciaDeTroca(projetoData)
                setShowApplyChangeButton(pendenteTroca)
                if (pendenteTroca){
                    setTrocaPendenteModal({ status: true, data: projetoData })
                }
            }
        })();
    }, [])

    useEffect(() => {
        if (projeto) {
            (async () => {
                const _rows = renderRows();
                edicaoRows$.next(_rows);
                await getDadosCalculo();
             })();
        }
    }, [projeto])

    const renderRows = useCallback(() => {
        return projeto?.componentes_modificados?.filter(c => {
            if (c.situacao === SITUACAO_COMPONENTE.EXCLUIDO && c.componente_substituido_id) {
                return false;
            }

            if ([SITUACAO_COMPONENTE.ALTERADO, SITUACAO_COMPONENTE.EXCLUIDO, SITUACAO_COMPONENTE.ORIGINAL, SITUACAO_COMPONENTE.SUBSTITUIDO].includes(c.situacao)) {
                return true;
            }

            if (SITUACAO_COMPONENTE.NOVO && c.componente_substituido_id === null) {
                return true;
            }

            return false;
        })?.map((c: any, index) => {
            const substitutos: any = projeto?.componentes_modificados?.filter((m: any) => m.componente_substituido_id === c.componente_id) || [];
            return <RowComponente 
                key={`row-componente-${projeto.codigo_venda}-${c.componente_id}-${index}`}
                componente={c}
                substitutos={substitutos}
                indexRow={index}
                onChange={(componente, index, substituto) => {

                    const modificados = projeto?.componentes_modificados || [];
                    const modificadoIndex = modificados.findIndex((m: any) => m.componente_id === componente.componente_id);
                    if (modificadoIndex > -1) {

                        if (componente?.valor && componente?.valor_unitario &&  componente?.quantidade) {
                            const valorUnitarioModificado = DecimalUtil.toFixed(componente.quantidade > 0 ? componente.valor / componente.quantidade : componente.valor, 2);
                            modificados[modificadoIndex].valor_unitario = valorUnitarioModificado;
                            modificados[modificadoIndex].valor = DecimalUtil.toFixed(valorUnitarioModificado * componente.quantidade, 2);
                            
                            // if (componente.valor !== modificados[modificadoIndex].valor) {
                            //     modificados[modificadoIndex].valor = componente.valor
                            // } else if (componente?.quantidade !== modificados[modificadoIndex].quantidade) {
                            //     modificados[modificadoIndex].valor = componente.valor_unitario * componente.quantidade
                            // }
                        }

                        modificados[modificadoIndex].quantidade = componente.quantidade || modificados[modificadoIndex].quantidade;
                        
                        // VÁLIDA SITUAÇÃO
                        if (componente?.situacao !== SITUACAO_COMPONENTE.NOVO && componente?.situacao !== SITUACAO_COMPONENTE.EXCLUIDO) {
                            if (modificados[modificadoIndex].situacao !== SITUACAO_COMPONENTE.SUBSTITUIDO && (DecimalUtil.toFixed(componente.valor || 0, 2) !== DecimalUtil.toFixed(modificados[modificadoIndex].valor_original || 0, 2) || componente.quantidade !== modificados[modificadoIndex].quantidade_original)) {
                                modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.ALTERADO;
                            } else if ((componente.quantidade === modificados[modificadoIndex].quantidade_original && componente.valor === modificados[modificadoIndex].valor_original) ) {
                                if (modificados.some((m: any) => m.componente_substituido_id === modificados[modificadoIndex].componente_id && m.situacao !== SITUACAO_COMPONENTE.EXCLUIDO)) {
                                    modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.SUBSTITUIDO
                                } else if (componente.situacao === SITUACAO_COMPONENTE.ALTERADO) {
                                    modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.ALTERADO
                                } else {
                                    modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.ORIGINAL
                                }
                            }
                        }

                        setProjeto({...projeto, componentes_modificados: [...modificados]})
                    }
                }}
                onReactive={(componenteId) => {
                    const modificados = projeto?.componentes_modificados || [];

                    const modificadoIndex = modificados.findIndex((m: any) => m.componente_id === componenteId);

                    if (modificadoIndex > -1) {
              
                        if (modificados[modificadoIndex].situacao !== SITUACAO_COMPONENTE.SUBSTITUIDO) {
                            modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.ALTERADO
                        }

                        setProjeto({...projeto, componentes_modificados: [...modificados]})
                    }
                }}
                onDelete={(componenteId) => {
                    const modificados = projeto?.componentes_modificados || [];

                    const modificadoIndex = modificados.findIndex((m: any) => m.componente_id === componenteId);

                    if (modificadoIndex > -1) {
                        const substituidoIndex = modificados.findIndex((m: any) => m.componente_id === modificados[modificadoIndex].componente_substituido_id);
                        if (modificados[modificadoIndex].situacao === SITUACAO_COMPONENTE.NOVO && !modificados[modificadoIndex]?.id) {
                            if (modificados[modificadoIndex].componente_substituido_id) {
                                const countSubstitutos = Number(modificados?.filter(c => c.componente_substituido_id === modificados[modificadoIndex].componente_substituido_id && c.componente_id !== componenteId)?.length)
                                if (substituidoIndex > -1 && countSubstitutos === 0) {
                                    modificados[substituidoIndex].situacao = SITUACAO_COMPONENTE.ORIGINAL
                                }
                            }
                            modificados.splice(modificadoIndex, 1);
                        } else {
                            if (substituidoIndex !== -1) {
                                const componenteSubstituido = modificados[substituidoIndex]
                                const alterado = (DecimalUtil.toFixed(componenteSubstituido.valor || 0, 2) !== DecimalUtil.toFixed(componenteSubstituido.valor_original || 0, 2) || (componenteSubstituido.quantidade !== componenteSubstituido.quantidade_original))
                                modificados[substituidoIndex].situacao =  alterado ? SITUACAO_COMPONENTE.ALTERADO : SITUACAO_COMPONENTE.ORIGINAL
                                modificados[substituidoIndex].componente_substituido_id =  null
                            }
                            modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.EXCLUIDO
                        }
                        setProjeto({...projeto, componentes_modificados: [...modificados]})
                    }
                }}
                callAddComponente={ (_c) => {
                    const id: number = parseInt(`${_c.componente_id}`)
                        const idCategoria: number = parseInt(`${_c.categoria_componentes_id}`)
                        setAcao(ACAO_SUBSTITUICAO);
                        setCategoria(idCategoria);
                        handleNotIn();
                        setComponenteEdicao(id);
                        setOpenModal(true);

                }}
                onRecalc={async (componenteId) => {
                    const modificados = projeto?.componentes_modificados || [];
                    const _modificado = modificados.find((m: any) => m.componente_id === componenteId);
                    if (_modificado && ![SITUACAO_COMPONENTE.EXCLUIDO, SITUACAO_COMPONENTE.SUBSTITUIDO].includes(_modificado.situacao)) {
                        await getDadosCalculo();
                    }
                }}
            />
        })
    }, [projeto]);

    return (
        <div className="EdicaoAvancada1">
            <div className="informacaoes X12">
                <div className="row">
                    <div className="X4">
                        <InputInfo
                            label="Codigo do projeto"
                            text={projeto?.codigo_venda}
                        />
                    </div>
                    <div className="X4">
                        <InputInfo
                            label="Valor do serviço"
                            text={renderValorServico()}
                        />
                    </div>
                    <div className="X4">
                        <InputInfo
                            label="Cidade/UF cliente"
                            text={renderUfCliente()}
                        />
                    </div>
                    <div className="X4">
                        <InputInfo
                            label="Valor dos componentes"
                            text={renderValor()}
                        />
                    </div>
                    <div className="X4">
                        <InputInfo
                            label="Potência"
                            text={renderPotencias()}
                        />
                    </div>
                    <div className="X4">
                        <InputInfo
                            label="Peso do telhado"
                            text={renderPesoTelhado()}
                        />
                        </div>
                    <div className="X4">
                        <InputInfo
                            label="Peso do gerador"
                            text={renderPesoGerador()}
                        />
                        </div>
                    <div className="X4">
                        <InputInfo
                            label="Área total"
                            text={renderArea()}
                        />

                    </div>
                </div>
            </div>
            <div className="row">
                <div className="X12">
                    <Divider />
                </div>
                <div className="X12" style={{ textAlign: "left" }}>
                    <h4>Componentes do pedido</h4>
                </div>
                <div className="componentes X12">
                    <TableContainer style={{ /* maxHeight: "400px" */ }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={112}>Situação</TableCell>
                                    <TableCell align="right">Código</TableCell>
                                    <TableCell>Modelo</TableCell>
                                    <TableCell width={80} align={Formater.toAlign(TypeRecords.INT)}>Qtd.original</TableCell>
                                    <TableCell width={80} align={Formater.toAlign(TypeRecords.INT)}>Quantidade</TableCell>
                                    <TableCell align={Formater.toAlign(TypeRecords.CURRENCY)}>Valor unitário</TableCell>
                                    <TableCell align={Formater.toAlign(TypeRecords.CURRENCY)}>Valor Total</TableCell>
                                    {!readOnly && <TableCell />}
                                    {!readOnly && <TableCell width={62} />}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </div>
            </div>

            <BottomBar>
                <FullWidthButton
                    text={"Novo componente"}
                    color={"secondary"}
                    variant="contained"
                    disabled={loading}
                    disableElevation
                    onClick={() => {
                        setAcao(ACAO_NOVO);
                        setCategoria(0);
                        handleNotIn();
                        setOpenModal(true);
                    }}
                />
                {showApplyChangeButton && (
                    <>
                        <Divider orientation="vertical" flexItem />
                        <FullWidthButton
                            text={"Aplicar Troca"}
                            color={"primary"}
                            variant="outlined"
                            disabled={loading || possuiPrecoZero(projeto?.componentes_modificados || [])}
                            disableElevation
                            onClick={async () => {
                                if (possuiPrecoZero(projeto?.componentes_modificados || [])) return;
                                /*
                                const _componentesModificados = state?.componentes_modificados?.filter(c => c.situacao !== SITUACAO_COMPONENTE.ORIGINAL) || []; 
                                if (_componentesModificados.length === 0) {
                                    notifierStore.setNotifier({
                                        title: "Aviso",
                                        content: ["Não há componentes para aplicar troca!"],
                                        onClose: () => {
                                            notifierStore.setOpen(false)
                                        },
                                        timeOut: 2_500,
                                    })
                                    notifierStore.setOpen(true);
                                    return;
                                }
                                */

                                confirmationDialog.setup({
                                    title: "Atenção!!!",
                                    content: "Deseja aplicar a troca?",
                                    onConfirmation: async () => {
                                        await salvar({ showNotification: false })
                                        confirmationDialog.close();
                                    },
                                    onClose: () => {
                                        confirmationDialog.close();
                                    }
                                })
                                confirmationDialog.open();
                            }}
                        />
                    </>
                )}
                <FullWidthButton
                    text={"Salvar e enviar e-mail"}
                    color={"primary"}
                    variant="outlined"
                    disabled={loading || possuiPrecoZero(projeto?.componentes_modificados || [])}
                    disableElevation
                    onClick={() => {
                        if (possuiPrecoZero(projeto?.componentes_modificados || [])) return;
                        setOpenModalEmail(true)
                    }}
                />
                <Divider orientation="vertical" flexItem />
                
                <FullWidthButton
                    text={"Cancelar"}
                    disabled={loading}
                    color={"secondary"}
                    onClick={() => {
                        history.goBack();
                        // onExit();
                    }}
                />
                
                <FullWidthButton
                    disableElevation={true}
                    disabled={loading || possuiPrecoZero(projeto?.componentes_modificados || [])}
                    text={"Salvar"}
                    color={"primary"}
                    variant={"contained"}
                    onClick={() => {
                        if (possuiPrecoZero(projeto?.componentes_modificados || [])) return;

                        const pendenteAplicacao = verificaPendenciaDeTroca(projeto)
                        confirmationDialog.setup({
                            title: "Atenção!!!",
                            content: pendenteAplicacao ? "Deseja salvar as alterações?" : "Deseja salvar e aplicar as alterações?",
                            onConfirmation: async () => {
                                await salvar()
                                confirmationDialog.close();
                            },
                            onClose: () => {
                                confirmationDialog.close();
                            },
                        })
                        confirmationDialog.open();
                    }}
                />

            </BottomBar>

            <AddComponente
                open={openModal}
                categoria={categoria}
                componentesCache={componentesCache}
                // estabelecimento={estabelecimentoSelecionado}
                notIn={notIn}
                onChangeValue={(componente) => {
                    handleAddComponente(componente);
                }}
                onClose={() => {
                    const _projeto: any = { ...projeto }
                    setProjeto(_projeto)
                    setOpenModal(false);
                }}

            />

            {trocaPendenteModal.status && <TrocaPendente
                open={trocaPendenteModal.status}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick') return;
                    setTrocaPendenteModal({ status: false, data: null })
                }}
                onConfirm={async() => {
                    await salvar({ showNotification: false })
                    setTrocaPendenteModal({ status: false, data: null })
                }}
                onCancel={async (componentesIds: number[], componentesNovosIds: number[], componentesRemovidosIds: number[]) => {
                    const modificados = [...(projeto?.componentes_modificados || [])]
                    componentesIds.forEach(componenteId => {
                        const modificadoIndex = modificados.findIndex((m: any) => m.componente_id === componenteId);
                        if (modificadoIndex !== -1) {
                            const substituidoIndex = modificados.findIndex((m: any) => m.componente_id === modificados[modificadoIndex]?.componente_substituido_id);
                            if (substituidoIndex !== -1) {
                                const componenteSubstituido = modificados[substituidoIndex]
                                const alterado = (DecimalUtil.toFixed(componenteSubstituido.valor || 0, 2) !== DecimalUtil.toFixed(componenteSubstituido.valor_original || 0, 2) || (componenteSubstituido.quantidade !== componenteSubstituido.quantidade_original))
                                modificados[modificadoIndex].situacao = SITUACAO_COMPONENTE.EXCLUIDO
                                modificados[substituidoIndex].situacao =  alterado ? SITUACAO_COMPONENTE.ALTERADO : SITUACAO_COMPONENTE.ORIGINAL
                                modificados[substituidoIndex].componente_substituido_id = null
                            }
                        }
                    })

                    componentesNovosIds.forEach(novoComponenteId => {
                        const novoIndex = modificados.findIndex((m: any) => m.componente_id === novoComponenteId);
                        if (novoIndex !== -1) {
                            modificados[novoIndex].situacao = SITUACAO_COMPONENTE.EXCLUIDO
                        }
                    })

                    componentesRemovidosIds.forEach(componenteRemovidoId => {
                        const removidoIndex = modificados.findIndex((m: any) => m.componente_id === componenteRemovidoId);
                        if (removidoIndex !== -1) {
                            const componenteRemovido = modificados[removidoIndex]
                            const alterado = (DecimalUtil.toFixed(componenteRemovido.valor || 0, 2) !== DecimalUtil.toFixed(componenteRemovido.valor_original || 0, 2) || (componenteRemovido.quantidade !== componenteRemovido.quantidade_original))
                            modificados[removidoIndex].situacao = alterado ? SITUACAO_COMPONENTE.ALTERADO : SITUACAO_COMPONENTE.ORIGINAL
                        }
                    })

                    setProjeto(old => ({ ...old, componentes_modificados: modificados }))
                    await salvar({ enviarPagamento: false, modificados, showNotification: false })
                    setTrocaPendenteModal({ status: false, data: null })
                }}
                data={trocaPendenteModal.data}
            />}

            <EmailDialog 
                modelos={modelosEmail}
                isOpen={openModalEmail}
                onClose={() => setOpenModalEmail(false)}
                sendMail={async (corpo) => {
                    const pendenteAplicacao = verificaPendenciaDeTroca(projeto)
                    
                    confirmationDialog.setup({
                        title: "Atenção!!!",
                        content: pendenteAplicacao ? "Deseja salvar as alterações e enviar o e-mail?" : "Deseja salvar, aplicar as alterações e enviar o e-mail?",
                        onConfirmation: async () => {
                            await salvarEnviarEmail(corpo);
                            confirmationDialog.close();
                        },
                        onClose: () => {
                            confirmationDialog.close();
                        },
                    })
                    confirmationDialog.open();
                }}
            />
        </div>
    );
}

export { EdicaoAvancada }
